import React from 'react'
import { useModals } from 'hooks'
import CreateReportModalContainer from 'components/report/create/CreateReportModalContainer'
import OrganizationHeader from 'components/organization/OrganizationHeader'

export default function ReportsHeader() {
  const { openModal } = useModals()
  const handleCreateReport = () => openModal(CreateReportModalContainer, {}, 'semi')

  return <OrganizationHeader button={{ onClick: handleCreateReport, text: '+ New Report' }} />
}
